import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "list", "view", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `operations--products--clinics--financials--takers--dashboard`
    this.setAccountPermission()
  }

  doTakersDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-7 pr-1" data-${this.controllerName}-target="list" data-controller="operations--products--clinics--regularizations--takers--index"></div>
                  <div class="col-5 pl-1" data-${this.controllerName}-target="view" data-controller="operations--products--clinics--regularizations--takers--save operations--products--clinics--regularizations--takers--show"></div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`operations--products--clinics--financials--show--main`).contentTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier(`operations--products--clinics--financials--show--submenu`).dashboardToggleBtn(`TOMADORES`)

      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--takers--index`).permission = controller.permission
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--takers--show`).permission = controller.permission
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--takers--show`).contact_permission = controller.contact_permission
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--takers--show`).info_permission = controller.info_permission
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--takers--save`).permission = controller.permission

      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--takers--index`).doIndexListHtml()
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--takers--show`).doViewHtml()
    })
  }

  setAccountPermission() {
    if (this.application.current_user.account_kind == `admin` || this.application.current_user.account_kind == `team`) {
      this.permission = `medclinic_financial_takers`
      this.contact_permission = `medclinic_financial_taker_contacts`
      this.info_permission = `medclinic_financial_taker_infos`
    }
    
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
